export default __webpack_public_path__ + "static/font-a2a393f326fe10428d497fb359c219f0.eot";